<template>
  <!-- Table Container Card -->
  <div>
    <add-new-users :is-add-new-users-sidebar-active.sync="isAddNewUsersSidebarActive"
      @clickaddNewUser="clickaddNewUser" />
    <add-edit-users :is-add-edit-users-sidebar-active.sync="isAddEditUsersSidebarActive" :editDataProps="editDataProps"
      @clickEditUser="clickEditUser" />
    <add-change-password :is-add-change-password-sidebar-active.sync="isAddChangePasswordSidebarActive
      " :changePasswordId="changePasswordId" @clickaddChangePasswordUser="clickaddChangePasswordUser" />
    <assign-permission-user :is-assign-permission-user-sidebar-active.sync="isAssignPermissionUserSidebarActive
      " :assignUserId="assignUserId" @clickAssignUser="clickAssignUser" />
    <b-card no-body>
      <div class="m-2">
        <!-- Table Top -->
        <b-row>

          <b-col cols="3" md="3" class="pl-0 pr-0">
            <v-select class="ml-1" v-model="selectedStatus" :options="statusData" :filterable="false"
              placeholder="Select Status" :style="CustomFontSize">
            </v-select>

          </b-col>

          <b-col cols="12" md="6" v-if="addpermissionHideButton == true">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input v-model="searchQuery" class="d-inline-block mr-1" placeholder="Search..." />
              <b-button variant="primary" v-if="removeButtons == true" @click="addNewUsers()">
                <span class="text-nowrap">Add User</span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table-simple v-if="addpermissionHideButton == true" hover caption-top responsive class="rounded-bottom mb-0">
        <b-thead head-variant="light">
          <b-tr>
            <b-th>No.</b-th>
            <b-th>User Name</b-th>
            <b-th>User Image</b-th>
            <b-th>Email</b-th>
            <b-th>Profile Id(App)</b-th>
            <b-th>Role Name</b-th>
            <b-th>Allowed IP</b-th>
            <b-th>Status</b-th>
            <b-th v-if="removeButtons == true">Action</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <template v-for="(users_data, index) in filteredUsers">
            <b-tr :key="users_data._id">
              <b-td>
                {{ index + 1 }}
              </b-td>
              <b-td>
                {{ users_data.name }}
              </b-td>
              <b-td>
                <b-avatar size="50" class="mr-1" :src="users_data.avatar" />
                <!-- <b-img rounded :src="users_data.avatar" height="80" /> -->
              </b-td>

              <b-td> {{ users_data.email }}</b-td>
              <b-td> {{ users_data.appProfileId ? users_data.appProfileId : '_' }} </b-td>

              <!-- <b-td> </b-td> -->
              <b-td>
                <div style="margin-bottom: 10%; margin-top: 7px" v-for="(roleName, ind) in users_data.role_name"
                  :key="ind + 'roleName'">
                  <b-badge pill variant="primary" style="background: #6666; color: black">
                    {{ roleName }}
                  </b-badge>

                  <br />
                </div>
                <div style="margin-bottom: 10%; border-bottom: 2px solid #6666"></div>

                <div v-for="(data, indexThree) in users_data.classAccess" :key="indexThree + 'data'">
                  <b-badge pill variant="primary" style="background: #6666; color: black">
                    {{ data }}
                  </b-badge>

                  <br />
                </div>

                <div v-for="(subjectdata, indexFour) in users_data.subjectAccess" :key="indexFour + 'subjectdata'">
                  <b-badge pill variant="primary" style="background: #6666; color: black">
                    {{ subjectdata }}
                  </b-badge>

                  <br />
                </div>
              </b-td>
              <b-td>
                <template v-if="users_data.allowed_ips && users_data.allowed_ips.length">

                  <div v-for="(data, indexThree) in users_data.allowed_ips" :key="indexThree + 'data'" class="mb-0">
                    <b-badge pill variant="primary" style="background: #6666; color: black">
                      {{ data }}
                    </b-badge>
                  </div>

                </template>

                <template v-else>
                  N/A
                </template>
              </b-td>


              <b-td>
                <span v-if="users_data.status" class="d-flex align-items-center">

                  <CheckCircleIcon v-if="users_data.status === 'active'" size="14" class="text-success me-1"
                    style="margin-right: 5px" />

                  <XCircleIcon v-else-if="users_data.status === 'inactive'" size="14" class="text-danger me-1"
                    style="margin-right: 5px" />

                  {{ capitalize(users_data.status) }}
                </span>

                <span v-else>_</span>
              </b-td>



              <b-td style="height: 100px" v-if="removeButtons == true">
                <b-dropdown variant="link" no-caret>
                  <template #button-content>
                    <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
                  </template>

                  <b-dropdown-item @click="
                    editUserData(
                      users_data._id,
                      users_data.avatar,
                      users_data.name,
                      users_data.email,
                      users_data.role_name[0],
                      users_data.classids,
                      users_data.subjectsids,
                      users_data.primaryColor,
                      users_data.secondaryColor,
                      users_data.tretiaryColor,
                      users_data.appProfileId,
                      users_data.status,
                      users_data.ip_restricted,
                      users_data.allowed_ips,
                    )
                    ">
                    <feather-icon icon="EditIcon" />
                    <span class="align-middle ml-50">Edit</span>
                  </b-dropdown-item>

                  <b-dropdown-item @click="editChangePassword(users_data._id)">
                    <feather-icon icon="EditIcon" />
                    <span class="align-middle ml-50">Change Password</span>
                  </b-dropdown-item>
                  <b-dropdown-item @click="deleteUserAlert(users_data._id)">
                    <feather-icon icon="TrashIcon" />
                    <span class="align-middle ml-50">Delete</span>
                  </b-dropdown-item>
                </b-dropdown>
              </b-td>
            </b-tr>
          </template>

          <!-- <b-tr> -->
        </b-tbody>
      </b-table-simple>
      <!-- {{ this.table_data.level }} -->
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BImg,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BTableSimple,
  BThead,
  BTr,
  BTh,
  BTd,
  BTbody,
  BTfoot,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { BBreadcrumb } from "bootstrap-vue";
import { CheckCircleIcon, XCircleIcon } from 'vue-feather-icons'
import axios from "axios";
import Ripple from "vue-ripple-directive";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import AddNewUsers from "./app/list/users-list/AddNewUsers.vue";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import AddEditUsers from "./app/list/users-list/AddEditUsers.vue";
import AddChangePassword from "./app/list/users-list/AddChangePassword.vue";
import AssignPermissionUser from "./app/list/users-list/AssignPermissionUser.vue";
export default {
  components: {
    AddNewUsers,
    AddEditUsers,
    AssignPermissionUser,
    AddChangePassword,
    BBreadcrumb,
    BCard,
    BRow,
    ToastificationContent,
    BCol,
    BImg,
    CheckCircleIcon,
    XCircleIcon,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    BTableSimple,
    BThead,
    BTr,
    BTh,
    BTd,
    BTbody,
    BTfoot,
    vSelect,
  },
  directives: {
    Ripple,
  },

  data() {
    return {
      table_data: {},
      searchQuery: "",
      isAddNewUsersSidebarActive: false,
      isAddEditUsersSidebarActive: false,
      editDataProps: {},
      DeleteUserAlertMessage: "",
      isAddChangePasswordSidebarActive: false,
      changePasswordId: "",
      isAssignPermissionUserSidebarActive: false,
      selectedStatus: null,
      assignUserId: {
        id: "",
        roleName: "",
      },
      statusData: ['Active', 'Inactive'],
      addpermissionHideButton: false,
      removeButtons: "",
    };
  },
  created() {
    this.gettabledata();
  },
  mounted() {
    var newPermission = JSON.parse(localStorage.getItem("permission"));
    for (let index = 0; index < newPermission.permission.length; index++) {
      if (newPermission.permission[index] == "manage_users") {
        this.removeButtons = true;

        break;
      } else {
        this.removeButtons = false;
      }
    }
  },
  computed: {
    filteredUsers() {
      let data = this.table_data;

      // Filter by status dropdown
      if (this.selectedStatus) {
        data = data.filter(user =>
          user.status.toLowerCase() === this.selectedStatus.toLowerCase()
        );
      }

      // Filter by searchQuery
      if (this.searchQuery.trim().length > 0) {
        data = data.filter(user => {
          if (user.name) {
            return this.searchQuery
              .toLowerCase()
              .split(" ")
              .every(v => user.name.toLowerCase().includes(v));
          }
        });
      }

      return data;
    }
  },


  methods: {
    capitalize(value) {
      if (!value) return '_'
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    confirmText(i, j) {
      Swal.fire({
        title: "Are you sure?",
        text: "Do You want to delete this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          // Swal.fire("Deleted!", "Your file has been deleted.", "success");
          this.delete_role_from_user(i, j);
        }
      });
    },
    deleteUserAlert(i) {
      Swal.fire({
        title: "Are you sure?",
        text: "Do You want to delete this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          // Swal.fire("Deleted!", "Your file has been deleted.", "success");
          this.deleteUser(i);
        }
      });
    },
    deleteUser(id) {
      var userDeleteId = {
        id: "",
      };
      userDeleteId.id = id;
      axios
        .post(process.env.VUE_APP_API_URL + "/user/delete", userDeleteId, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("_t"),
          },
        })
        .then((response) => {
          // console.log(response);
          this.DeleteUserAlertMessage = response.data;
          this.userDelete("success");
          this.gettabledata();
        });
    },
    userDelete(variant) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Notification",
          icon: "BellIcon",
          text: this.DeleteUserAlertMessage,
          variant,
        },
      });
    },
    delete_role_from_user(role_id, index) {

      var deleted = {
        user_id: "",
        role_id_index: "",
      };
      deleted.user_id = role_id;
      deleted.role_id_index = index;
      axios
        .post(process.env.VUE_APP_API_URL + "/delete_role_from_user", deleted)
        .then((response) => {
          // console.log(response);
          if (response.data == "Successfully Remove") {
            this.removeRole("success", "top-left");
          } else {
            this.removeRolereject("danger", "top-left");
          }
          this.gettabledata();
        });
    },
    removeRole(variant, position) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "Remove role Successfully ",
            variant,
          },
        },
        {
          position,
        }
      );
    },
    removeRolereject(variant, position) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "Remove role fail.Try again ",
            variant,
          },
        },
        {
          position,
        }
      );
    },
    clickAssignUser(assign_role) {
      axios
        .post(process.env.VUE_APP_API_URL + "/assign_role_data", assign_role)
        .then((response) => {

          this.gettabledata();
        });
    },
    addRoleToUser(id, roleName) {
      // console.log("roleName",roleName)

      this.assignUserId.id = id;
      this.assignUserId.roleName = roleName;
      this.isAssignPermissionUserSidebarActive = true;
    },
    editUserData(
      id,
      avatar,
      name,
      email,
      roleName,
      classAccess,
      subjectAccess,
      first,
      second,
      third,
      appProfileId,
      status,
      ip_restricted,
      allowed_ips
    ) {
      this.editDataProps = {};
      // console.log();
      this.editDataProps.id = id;
      this.editDataProps.status = status;
      this.editDataProps.ip_restricted = ip_restricted;
      this.editDataProps.allowed_ips = allowed_ips;
      this.editDataProps.avatar = avatar;
      this.editDataProps.name = name;
      this.editDataProps.email = email;
      this.editDataProps.appProfileId = appProfileId;
      if (first) {
        this.editDataProps.first = first;
      } else {
        this.editDataProps.first = "";
      }
      if (second) {
        this.editDataProps.second = second;
      } else {
        this.editDataProps.second = "";
      }
      if (third) {
        this.editDataProps.third = third;
      } else {
        this.editDataProps.third = "";
      }

      if (roleName == "admin") {
        this.editDataProps.roleName = roleName;
        // this.editDataProps.classAccess = classAccess;
        // this.editDataProps.subjectAccess = subjectAccess;
      } else {
        this.editDataProps.roleName = roleName;
        this.editDataProps.classAccess = classAccess;
        this.editDataProps.subjectAccess = subjectAccess;
      }
      // console.log('this.editDataProps',this.editDataProps)
      //  console.log("this.editDataProps",this.editDataProps);

      this.isAddEditUsersSidebarActive = true;
    },
    clickaddNewUser: function (add_user_data) {
      axios
        .post(process.env.VUE_APP_API_URL + "/register", add_user_data, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("_t"),
          },
        })
        .then((response) => {
          // console.log("response.data.message", response.data.message);
          // "errors":{"email":["The email has already been taken."]}}
          if (response.data.success == true) {
            this.addNewUserReject("success");
          }
          // this.gettabledata();
          this.gettabledata();
        })
        .catch(function (error) {
          // console.log("error.response", error.response);
          this.addNewUserToast("danger");
          if (error.response) {
          } else if (error.request) {
            // The request was made but no response was received
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
          }
        });
    },

    addNewUserReject(variant) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Notification",
          icon: "BellIcon",
          text: "User Added successfully",
          variant,
        },
      });
    },
    addNewUserToast(variant) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Notification",
          icon: "BellIcon",
          text: "The email has already been taken.",
          variant,
        },
      });
    },
    clickEditUser: function (edit_user_data) {
      axios
        .post(process.env.VUE_APP_API_URL + "/user/data/edit", edit_user_data, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("_t"),
          },
        })
        .then((response) => {
          // console.log(response);
          if (response.data != "duplicate email") {
            this.showToa("success");
            this.gettabledata();
          } else {
            this.showToast("danger");
          }
          // this.gettabledata();
        });
    },
    clickaddChangePasswordUser: function (change_password_data) {
      axios
        .post(
          process.env.VUE_APP_API_URL + "/user/change/password",
          change_password_data,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("_t"),
            },
          }
        )
        .then((response) => {
          // console.log(response.message.d);
          if (response.data.message == "Password Update") {
            this.changepasswordSuccess("success", "top-right");
          } else {
            this.changepasswordreject("danger", "top-right");
          }

          this.gettabledata();
        });
    },
    changepasswordreject(variant, position) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "Password not change",
            variant,
          },
        },
        {
          position,
        }
      );
    },
    changepasswordSuccess(variant, position) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "Password change successfully",
            variant,
          },
        },
        {
          position,
        }
      );
    },
    showToa(variant) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Notification",
          icon: "BellIcon",
          text: "Edit successfully",
          variant,
        },
      });
    },
    showToast(variant) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Notification",
          icon: "BellIcon",
          text: "Soory! User not edit try another email",
          variant,
        },
      });
    },

    editChangePassword(id) {
      // console.log("id of user",id);
      this.isAddChangePasswordSidebarActive = true;
      this.changePasswordId = id;
    },
    addNewUsers() {
      this.isAddNewUsersSidebarActive = true;
    },
    gettabledata: function () {
      axios
        .get(process.env.VUE_APP_API_URL + "/cms/users/data", {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("_t"),
          },
        })
        .then((get_response) => {
          if (get_response.data.length == 0) {
            this.addpermissionHideButton = false;
          } else {
            this.addpermissionHideButton = true;
            this.table_data = get_response.data;
          }

          // console.log(get_response.data);
        })
        .catch(function (error) {
          console.log("error", error);
        });
    },
    getUsers() {
      //  this.forcRender();
      if (this.searchQuery.trim().length > 0) {
        return this.table_data.filter((item) => {
          // console.log(item);
          if (item.name) {
            return this.searchQuery
              .toLowerCase()
              .split(" ")
              .every((v) => item.name.toLowerCase().includes(v));
          }
        });
      } else {
        return this.table_data;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
